import { Upload } from 'antd'
import Flex from 'components/Flex'
import { Fragment } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const StyledUpload = styled(Upload)`
  .ant-upload {
    width: 100%;
  }
`
export const UploadFlex = styled(Flex)`
  margin: 25px 0 20px 0;
  border: 1px dashed ${COLORS.BLUE_T_80};
  border-radius: 8px;

  background: ${props => (props?.isBgWhite ? 'white' : `${COLORS.BLUE_T_97}`)};
  height: 150px;

  padding: 30px;
  cursor: pointer;
`
export const UploadIconDiv = styled.div`
  margin-bottom: 15px;
  text-align: center;
`
export const UploadFileDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_BASE};
  line-height: 20px;
  color: #30475e;
  margin-bottom: 5px;
  text-align: center;
`

export const FileNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: #b7bfc7;
  text-align: center;
`
export const HeadTextWrap = styled(Flex)`
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 16px;
  color: #202020;
`
export const FirstContent = styled.div`
  background: #f9fafe;
  border-radius: 4px;
  padding: 20px 16px; // equal top and bottom spacing
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const SubText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #4d566e;
  padding-left: 15px;
  margin-top: 8px;
  position: relative;
  line-height: 1.4;

  &::before {
    content: '•';
    position: absolute;
    left: 0;
    top: 0;
    color: #4d566e;
    font-size: 18px;
    line-height: 1;
    gap:10px;
  }
`;


export const CheckboxLabelWrapper = styled.div`
  margin-top: 20px;
`;

export const CheckboxLabel = styled.label`
  font-weight: ${FONT.FW_500};
  display: flex;
  align-items: center;
  font-size: ${FONT.F_BASE};
  color: #202020;
  input {
    margin-right: 8px;
  }
`;

// style.js

export const SampleDocWrapper = styled(Flex)`
  border: 1px solid ${COLORS.BLUE_T_80};
  border-radius: 8px;
  background: white;
  padding: 16px;
  margin-top: 20px;
  cursor: pointer;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 72px; 
`;

export const SampleDocIcon = styled.div`
  margin-right: 12px;
  display: flex;
  align-items: center;
`;

export const SampleDocContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SampleDocTitle = styled.div`
  font-weight: 500;
  color: #202020;
`;

export const SampleDocSubtitle = styled.div`
  font-size: 12px;
  color: #798291;
`;

export const NoteContent = styled.div`
  background: ${COLORS.BLUE_T_97};
  border-radius: 4px;
  border: none;
  padding: 10px 12px;
  margin-top: 16px;
`;
